import { computed, shallowRef, type ComputedRef, type ShallowRef } from 'vue'

import type { AddToDashboardPayload } from '../models/addToDashboard.types'

// One app-level bridge state. AppLayout mounts the modal once; any report control can open it
// without owning navigation, persistence or a second modal instance.
const activePayload = shallowRef<AddToDashboardPayload | null>(null)

export interface UseAddToDashboard {
  open: (payload: AddToDashboardPayload) => void
  close: () => void
  isOpen: ComputedRef<boolean>
  /** The mounted AddToDashboardModal consumes this; report callers only need open/close/isOpen. */
  payload: ShallowRef<AddToDashboardPayload | null>
}

export function useAddToDashboard(): UseAddToDashboard {
  return {
    open: (payload) => {
      activePayload.value = payload
    },
    close: () => {
      activePayload.value = null
    },
    isOpen: computed(() => activePayload.value !== null),
    payload: activePayload,
  }
}
